import { Component, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-modal-for-member-card',
    templateUrl: './modal-for-member-card.shared.component.html',
    styleUrls: ['./modal-for-member-card.shared.component.scss']
})
export class ModalForMemberCardComponent extends ModalViewComponent implements OnInit {
    public memberFirstName$: Observable<string>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xs';
        this.memberFirstName$ = this.controllers.members.getMemberFirstName$();
    }
}
